import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPhoneTopDynamicIsland: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconPhoneTopDynamicIsland"><Path d="M3.5 20.5002V6.50024C3.5 4.84339 4.84315 3.50024 6.5 3.50024H17.5C19.1569 3.50024 20.5 4.84339 20.5 6.50024V20.5002" stroke="currentColor" strokeLinecap="square"/><Path d="M11 5.75H13" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/></CentralIconBase>;
});

export default IconPhoneTopDynamicIsland;
